
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporatiu/premsa/contacte",
      function () {
        return require("private-next-pages/corporatiu/premsa/contacte/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporatiu/premsa/contacte"])
      });
    }
  